import React, { useState } from 'react';
import { Space } from 'antd';
import { ExclamationCircleFilled, WarningFilled } from '@ant-design/icons';
import { ChevronDownIcon, ChevronUpIcon } from '@/assets/icons/icons';
import CustomParagraph from '@/components/CustomParagraph';
import styles from './AlertBox.module.css';

interface AlertBoxProps {
  isCritical?: boolean;
  message?: string;
  title?: string;
  label?: string;
  /** The email panel's Figma sizes: 24 px alert icon, no gap before the chevron. */
  emailLayout?: boolean;
}

const AlertBox: React.FC<AlertBoxProps> = ({
  isCritical,
  message,
  title = 'Original alert:',
  label = 'Low battery',
  emailLayout,
}) => {
  const [open, setOpen] = useState(false);
  const contentId = 'alertbox-content';

  return (
    <div className={styles.box}>
      <div className={styles.header}>
        <Space size={8} align='center'>
          {isCritical ? (
            <span
              className={`${styles.icon} ${styles.iconCritical} ${
                emailLayout ? styles.iconEmail : ''
              }`}
            >
              <ExclamationCircleFilled />
            </span>
          ) : (
            <span
              className={`${styles.icon} ${styles.iconWarning} ${
                emailLayout ? styles.iconEmail : ''
              }`}
            >
              <WarningFilled />
            </span>
          )}

          <CustomParagraph
            text={`${title} ${label}`}
            fontSize='12px'
            fontWeight={600}
            style={{ margin: 0 }}
          />
        </Space>

        <div
          onClick={() => setOpen((v) => !v)}
          role='button'
          tabIndex={0}
          onKeyDown={(e) =>
            e.key === 'Enter' || e.key === ' ' ? setOpen((v) => !v) : null
          }
          aria-expanded={open}
          aria-controls={contentId}
          className={`${styles.toggle} ${emailLayout ? styles.toggleEmail : ''}`}
        >
          <CustomParagraph
            fontSize={'12px'}
            color='var(--text-secondary)'
            text={open ? 'Hide' : 'Show'}
            style={{ margin: 0 }}
          />
          {open ? (
            <ChevronUpIcon color='var(--text-secondary)' width={24} />
          ) : (
            <ChevronDownIcon color='var(--text-secondary)' width={24} />
          )}
        </div>
      </div>

      {open && (
        <div id={contentId} className={styles.content}>
          <CustomParagraph
            text={message}
            noText=''
            style={{ margin: 0, fontSize: 12, lineHeight: 1.5715 }}
            whiteSpace='pre-line'
          />
        </div>
      )}
    </div>
  );
};

export default AlertBox;
